if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    $("a.fancybox").fancybox();
    
    function msieversion() {

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
        {
          const image_fit = document.getElementsByClassName('object-fit');
          for(let i = 0; i < image_fit.length; i++ ){
            const this_image = image_fit[i].getElementsByTagName('img')[0];
            const image_data = this_image.dataset.srcset;
            const image_src = this_image.getAttribute('src');
            image_fit[i].classList.add('ie-bg');
            if(image_data){
              image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
            }else{
              image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
            }
    
          }
        }
        else
        {
          console.log('other browser');
        }
    
        return false;
    }
    
    
    msieversion()

    $('.quad-tabs__tabs ul li').click(function(){
        const thisTag = $(this).attr('data-tag');
        $('.grid--filter .grid__col').hide();
        $('.grid--filter .'+thisTag).fadeIn();
        $('.quad-tabs__tabs ul li').removeClass('active');
        $(this).addClass('active');
    })

    $('.services__filter ul li').click(function(){
        const thisTag = $(this).attr('data-tag');
        $('.grid--filter .grid__col').hide();
        $('.grid--filter .'+thisTag).fadeIn();
        $('.services__filter ul li').removeClass('active');
        $(this).addClass('active');
    })

    if(document.querySelector('.services')){
        const filter_item = document.querySelectorAll('.services__filter ul li'); filter_item[2].click();
    }

    if(document.querySelector('.quad-tabs')){
        const filter_tab = document.querySelectorAll('.quad-tabs__tabs ul li'); filter_tab[2].click();
    }

    //accordion filter module

    const tabAccordionElement = [...document.getElementsByClassName('js-title-toggle')] || [];
    const contentAccordionElement = [...document.getElementsByClassName('js-info-toggle')] || [];

    tabAccordionElement.forEach(function (elementTab) {
        elementTab.addEventListener('click', function () {
            const clickedElement = this;
            clickedElement.classList.toggle('change-icon');
            tabAccordionElement.forEach(function(elementClass) {
                if( elementClass !== clickedElement )
                    elementClass.classList.remove('change-icon');
                    elementClass.setAttribute('aria-expanded', 'false');
            });
            clickedElement.setAttribute('aria-expanded', 'true');
            contentAccordionElement.forEach(function (elementContent) {
                let dataElementTab = elementTab.dataset.expand;
                let dataElementContent = elementContent.dataset.expand;

                elementContent.classList.add('info-toggle');
                elementContent.setAttribute('aria-expanded', 'true');
                
                if(elementTab.classList.contains('change-icon')){
                    if(dataElementTab === dataElementContent){
                        elementContent.classList.remove('info-toggle');
                    }
                }else{
                    if(dataElementTab === dataElementContent){
                        elementContent.classList.add('info-toggle');
                    }
                }
            })
        });
    })

    //accordion module
    
    const tabAccordionElement2 = [...document.getElementsByClassName('js-title-toggle-2')] || [];
    const contentAccordionElement2 = [...document.getElementsByClassName('js-info-toggle-2')] || [];

    tabAccordionElement2.forEach(function (elementTab) {
        elementTab.addEventListener('click', function () {
            const clickedElement = this;
            clickedElement.classList.toggle('change-icon');
            tabAccordionElement2.forEach(function(elementClass) {
                if( elementClass !== clickedElement )
                    elementClass.classList.remove('change-icon');
                    elementClass.setAttribute('aria-expanded', 'false');
                    
            });
            clickedElement.setAttribute('aria-expanded', 'true');
            contentAccordionElement2.forEach(function (elementContent) {
                let dataElementTab = elementTab.dataset.expand;
                let dataElementContent = elementContent.dataset.expand;

                elementContent.classList.add('info-toggle');
                
                if(elementTab.classList.contains('change-icon')){
                    if(dataElementTab === dataElementContent){
                        elementContent.classList.remove('info-toggle');
                    }
                }else{
                    if(dataElementTab === dataElementContent){
                        elementContent.classList.add('info-toggle');
                    }
                }
            })
        });
    })
/** ADA Keyboard navigation functionality - opening and closing accordion modules **/
    document.addEventListener('DOMContentLoaded', function() {
        const acordions = document.querySelectorAll('.accordion-module__title-toggle');

        acordions.forEach(acordion => {
            acordion.addEventListener('keydown', function(event){
                if (event.key === 'Enter') {
                    const element = acordion.nextElementSibling;
                    element.classList.toggle('info-toggle');
                    acordion.classList.toggle('change-icon');
                }
            });
        });
    });

    /// show menu mobile

    function showMenu(){
        let openMenu = document.querySelector('#menu-btn');
        let menu = document.querySelector('#menu-mobile');
        let close = document.querySelector('#close');
        if(openMenu){
			openMenu.addEventListener('click', event=>{
				menu.classList.add('show');
			})
		}
		if(close){
			close.addEventListener('click', event=>{
				menu.classList.remove('show');
			})
		}
    };

    showMenu();

    //vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open')
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open')
			});
		}
	}

})();